/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { ScreenType } from 'client-code/previews';
import { PreviewsRepositoryImpl } from '../impls/PreviewsServiceRepositoryImpl';
import { IPreviewsServiceRepository } from '../interfaces/IPreviewsServiceRepository';
import { TOfferPreview } from '../types/TOfferPreview';
import { TServicesParams } from '../types/TServicesParams';

export class PreviewsService implements IPreviewsServiceRepository {
    private oPreviewsServiceRepository: IPreviewsServiceRepository;

    constructor(params: TServicesParams) {
        this.oPreviewsServiceRepository = new PreviewsRepositoryImpl(params);
    }

    async fetchOfferPreview(
        offerId: string,
        screenType: ScreenType,
        networkCallId?: number,
    ): Promise<TOfferPreview> {
        return this.oPreviewsServiceRepository.fetchOfferPreview(
            offerId,
            screenType,
            networkCallId,
        );
    }

    async fetchVodOfferPreview(
        vodOfferId: string,
        screenType: ScreenType,
        networkCallId?: number,
    ): Promise<TOfferPreview> {
        return this.oPreviewsServiceRepository.fetchVodOfferPreview(
            vodOfferId,
            screenType,
            networkCallId,
        );
    }
}
